export enum CompositeKeys {
  'Shift' = 'SHIFT+',
  'Ctrl' = 'CTRL+',
  'Alt' = 'ALT+',
  'Meta' = 'META+',
}
